import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const sectionHeading = css({
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const specialOfferCard = css({
  marginBottom: 'default',
});

export const specialOfferHeading = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  fontWeight: 'bold',
  fontSize: 'body',
  color: 'text.neutral',
  marginBottom: 'tightest',
});

export const specialOfferBody = css({
  fontSize: 'body-sm',
});

export const totalAmount = css({
  fontSize: 'heading-sm',
  fontWeight: 'bold',
  color: 'text.accent.brand.hero',
  lineHeight: 'heading-sm',
  overflowWrap: 'anywhere',
  lg: {
    fontSize: 'heading-md',
    lineHeight: 'heading-md',
  },
});

export const totalLabel = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.neutral',
  fontWeight: 'bold',
  marginBottom: 'tighter',
});

export const summaryList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
  margin: 0,
});

export const summaryRow = css({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  columnGap: 'default',
  alignItems: 'baseline',
  paddingBlock: 'tightest',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const summaryLabel = css({
  color: 'text.subtle',
});

export const summaryValue = css({
  margin: 0,
  fontWeight: 'bold',
  color: 'text.neutral',
  textAlign: 'right',
});

export const leaseTermsContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tighter',
  marginTop: 'tightest',
});

export const leaseTermPill = css({
  paddingInline: 'default',
  paddingBlock: 'tightest',
  borderRadius: 'pill',
  fontSize: 'body-sm',
  fontWeight: 'regular',
  backgroundColor: 'brand.primary',
  color: 'white',
  border: 'none',
});

export const leaseTermsText = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  margin: 0,
});

export const footerContainer = css({
  marginTop: 'default',
});
